import { SearchParams, SearchResponse } from 'typesense/lib/Typesense/Documents'
import { MultiSearchRequestSchema } from 'typesense/lib/Typesense/MultiSearch'

import {
  AddressValue,
  DateValue,
  ImageValue,
} from '@bonhams1793/bonhams-typescript'

import { getDateNowUtc } from '@nx/dates'

import { TypesenseClientInstance } from '../typesenseClient'
import { extractDocuments } from '../typesenseHelpers'

export interface TypesenseValuationEvent {
  id: string
  auctionId?: number | null
  name: string
  description: string
  summary: string
  isLocationVenue: boolean
  image?: ImageValue | null
  dates: {
    start: DateValue
    end: DateValue
  }
  location: {
    code: string
    name: string
  }
  categories: { code: string; name: string }[]
  address: AddressValue
  departments: { code: string; name: string }[]
  contact: {
    emailAddress: string
    phoneNumber: string
  }
  people: number[]
  highlights: {
    auctionId: number
    lotNumber: string
    previewLot: boolean
    lotIdUnique: number
    name: string
    image: ImageValue
    hammerPrice: number
    hammerPremium: number
    currencySymbol: string
    currencySymbol2: string
    currencySymbol3: string
  }[]
}

export interface GetTypesenseValuationEventsParams extends SearchParams {
  perPage?: MultiSearchRequestSchema['per_page']
  page?: MultiSearchRequestSchema['page']
  sortBy?: string
  locationCode?: string
  inTheFuture?: boolean
}

export type TypesenseValuationEventsSearchResponse = Omit<
  SearchResponse<TypesenseValuationEvent>,
  'hits'
> & {
  hits: TypesenseValuationEvent[]
}

export function getTypesenseValuationEvents({
  typesenseRequest,
}: TypesenseClientInstance) {
  return async ({
    perPage = 14,
    page = 1,
    sortBy = 'dates.start.timestamp:desc',
    locationCode,
    inTheFuture,
    filter_by = '',
  }: GetTypesenseValuationEventsParams = {}): Promise<TypesenseValuationEventsSearchResponse> => {
    const filters = []

    if (locationCode) {
      // TODO remove `location.id` after backend is updated
      filters.push(`location.code:${locationCode}`)
    }

    if (inTheFuture) {
      let now = getDateNowUtc().seconds

      // Round to the nearest minute for cache busting
      now = Math.floor(now / 60) * 60

      filters.push(`dates.end.timestamp:>=${now}`)
    }

    if (filter_by) {
      filters.push(filter_by)
    }

    const mainResponse = await typesenseRequest<
      SearchResponse<TypesenseValuationEvent>
    >('valuation-events', {
      query_by: '',
      q: '*',
      filter_by: filters.join(' && '),
      page,
      per_page: perPage,
      sort_by: sortBy,
    })
    return {
      ...extractDocuments(mainResponse),
    }
  }
}
